import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

export const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    
    // ✅ ESTILOS PARA EL MODAL PROFESIONAL
    dialogTitle: {
        background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
        color: "white",
        padding: theme.spacing(2),
        "& .MuiTypography-h6": {
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
        },
    },
    
    // ✅ CORREGIDO: DialogContent dinámico según tema
    dialogContent: {
        padding: theme.spacing(2),
        backgroundColor: theme.mode === 'dark' ? '#1f2937' : "#fafbfc",
    },
    
    // ✅ CORREGIDO: FormSection dinámico según tema
    formSection: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: "10px",
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        boxShadow: theme.mode === 'dark' ? "0 1px 6px rgba(0,0,0,0.3)" : "0 1px 6px rgba(0,0,0,0.08)",
        border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e3f2fd'}`,
    },
    
    // ✅ CORREGIDO: SectionTitle dinámico según tema
    sectionTitle: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: "15px",
    },
    
    // ✅ CORREGIDO: FormField dinámico según tema
    formField: {
        marginBottom: theme.spacing(1.5),
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
            color: theme.palette.text.primary,
            "& fieldset": {
                borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        "& .MuiInputLabel-root": {
            color: theme.palette.text.secondary || theme.palette.text.primary,
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: theme.palette.primary.main,
        },
        "& .MuiFormHelperText-root": {
            color: theme.palette.text.secondary || theme.palette.text.primary,
        },
    },
    
    multFieldLine: {
        display: "flex",
        gap: theme.spacing(1.5),
        "& > *": {
            flex: 1,
        },
    },
    
    // ✅ ESTILOS PARA BOTONES
    btnWrapper: {
        position: "relative",
    },
    
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    
    // ✅ CORREGIDO: CancelButton dinámico según tema
    cancelButton: {
        backgroundColor: theme.mode === 'dark' ? 'rgba(211, 47, 47, 0.2)' : "#ffebee",
        color: "#d32f2f",
        fontWeight: "bold",
        borderRadius: "8px",
        padding: "12px 24px",
        "&:hover": {
            backgroundColor: theme.mode === 'dark' ? 'rgba(211, 47, 47, 0.3)' : "#ffcdd2",
        },
    },
    
    saveButton: {
        background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
        fontWeight: "bold",
        borderRadius: "8px",
        padding: "12px 24px",
        boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
        "&:hover": {
            background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
        },
    },
    
    // ✅ CORREGIDO: InfoBox dinámico según tema
    infoBox: {
        backgroundColor: theme.mode === 'dark' ? '#1e3a5f' : "#f0f8ff",
        border: `1px solid ${theme.mode === 'dark' ? '#2d4f7a' : '#e3f2fd'}`,
        borderRadius: "8px",
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    },
    
    // ✅ CORREGIDO: InfoText dinámico según tema
    infoText: {
        color: theme.palette.primary.main,
        fontSize: "13px",
        marginBottom: theme.spacing(0.75),
    },
    
    // ✅ CORREGIDO: LinkText dinámico según tema
    linkText: {
        color: theme.palette.primary.main,
        textDecoration: "none",
        fontWeight: "bold",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    
    // ✅ ESTILOS PARA CHIPS DE PROVEEDOR
    providerChip: {
        backgroundColor: "#e8f5e8",
        color: "#2e7d32",
        fontWeight: "bold",
        margin: "4px",
    },
    
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    
    // ✅ CORREGIDO: FormControl dinámico según tema
    formControlDynamic: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
            color: theme.palette.text.primary,
            "& fieldset": {
                borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        "& .MuiInputLabel-root": {
            color: theme.palette.text.secondary || theme.palette.text.primary,
        },
        "& .MuiMenuItem-root": {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            "&:hover": {
                backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
            },
        },
    },
    
    colorAdorment: {
        width: 20,
        height: 20,
    },
    
    // ✅ CORREGIDO: DialogActions dinámico según tema
    dialogActions: {
        padding: "16px 24px",
        backgroundColor: theme.mode === 'dark' ? '#1f2937' : "#f8f9fa",
        borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    },
    
    // ✅ ESTILOS PARA EL MODAL AMPLIADO
    expandedPromptHelper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: theme.spacing(0.5),
        width: "100%",
    },
    
    expandedPromptButton: {
        marginLeft: theme.spacing(1),
        textTransform: "none",
        fontSize: "12px",
    },
    
    expandedPromptDialog: {
        "& .MuiDialog-paper": {
            maxWidth: "90vw",
            width: "90vw",
            maxHeight: "90vh",
            height: "90vh",
        },
    },
    
    expandedPromptContent: {
        padding: theme.spacing(3),
        height: "calc(90vh - 120px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    
    expandedPromptEditor: {
        flex: 1,
        marginTop: theme.spacing(2),
        minHeight: "300px",
        "& .MuiOutlinedInput-root": {
            height: "100%",
            alignItems: "flex-start",
            fontSize: "14px",
            lineHeight: "1.6",
            fontFamily: "'Courier New', monospace",
            backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff',
            color: theme.palette.text.primary,
            "& textarea": {
                height: "100% !important",
                overflow: "auto !important",
                padding: theme.spacing(2),
            },
        },
    },
    
    expandedPromptPreview: {
        flex: 1,
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f9fafb',
        borderRadius: "8px",
        border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
        overflow: "auto",
        fontSize: "14px",
        lineHeight: "1.8",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        fontFamily: "'Courier New', monospace",
        minHeight: "200px",
    },
}));
